import React, {useState, useRef} from "react";
import ExpandableInputGroup from "./ExpandableInputGroup";
import LinedInput, {InputType} from "./LinedInput";

export default function DemoInputGroup() {
    const [groupExpanded, setGroupExpanded] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const inputRefFirst = useRef<HTMLInputElement>(null);
    const inputRefLast = useRef<HTMLInputElement>(null);

    return (
        <ExpandableInputGroup
            isExpanded={groupExpanded}
            isValid={
                !!inputRefFirst.current?.validity.valid && !!inputRefLast.current?.validity.valid
            }
            name="Name"
            setIsExpanded={setGroupExpanded}
            value={`${firstName} ${lastName}`}
        >
            {(inputProps) => (
                <>
                    <LinedInput
                        {...inputProps}
                        ref={inputRefFirst}
                        id="group-first-name"
                        type={InputType.Text}
                        value={firstName}
                        setValue={setFirstName}
                        label="First Name"
                        required={true}
                    />
                    <LinedInput
                        {...inputProps}
                        ref={inputRefLast}
                        id="group-last-name"
                        type={InputType.Text}
                        value={lastName}
                        setValue={setLastName}
                        label="Last Name"
                        required={true}
                    />
                </>
            )}
        </ExpandableInputGroup>
    );
}
